<app-system-error *ngIf="onError"></app-system-error>

<main *ngIf="onSuccess">
  <div id="headerSection" class="grid-container">
    <h1 id="changeFlightPageTitle">{{ "reaccom.pageTitle" | translate }}</h1>
  </div>
  <div class="table-cloth __blue">
    <div class="grid-container">
      <app-trip-update-card [changeInfo]="changeInfo"></app-trip-update-card>
    </div>
  </div>
  <div class="table-cloth __gray">
    <div class="grid-container">
      <section id="changeFlightUpdated" class="flight-card card" *ngIf="pageLoadFlag" aria-labelledby="updatedFlightHeading">
        <div class="card-section">
          <h2 id="updatedFlightHeading" class="text-brand-blue h5">{{ "reaccom.section.updatedFlight" | translate }}</h2>
          <div class="flight-details-summary" *ngFor="let slices of updateFlights as results; let i = index; let isLastSlice = last">
            <div *ngFor="let flightDetails of slices as results; let i = index; let isLastSegment = last">
              <app-flight-card [flightDetails]="flightDetails" [lastSegment]="isLastSegment" [lastSlice]="isLastSlice"
                [localeStr]="locale" [timeFormat]="timeFormat"></app-flight-card>
            </div>
          </div>
        </div>
      </section>
      <section id="changeFlightOriginal" class="flight-card card" *ngIf="pageLoadFlag" aria-labelledby="origFlightHeading">
        <div class="card-section">
          <h2 class="margin-bottom h5 text-brand-blue expander" id="origFlightHeading" (click)="expandCollapse()">
            <button class="expander-target" aria-controls="changeFlightDetails" [attr.aria-expanded]="isCollapsed" role="button"
              tabindex="0" id="flight-container-original-expand">
              <span class="{{ expandCollapseIcon }} icon-medium show-for-medium"></span>
              <span class="expander-text leadingWhtSpc">{{'reaccom.section.originalFlight' | translate}}</span>
            </button>
            <span class="{{ expandCollapseIcon }} icon-medium hide-for-medium float-right"></span>
          </h2>
          <section id="changeFlightDetails" *ngIf="isCollapsed">
            <div class="flight-details-summary" *ngFor="let slices of originalFlights as results; let i = index; let isLastSlice = last">
              <div *ngFor="let flightDetails of slices as results; let i = index; let isLastSegment = last">
                <app-flight-card [flightDetails]="flightDetails" [lastSegment]="isLastSegment" [lastSlice]="isLastSlice"
                  [localeStr]="locale" [timeFormat]="timeFormat"></app-flight-card>
              </div>
            </div>
          </section>
        </div>
      </section>
      <div class="btn-row">
        <div class="grid-x grid-margin-x">
          <div class="cell small-12 medium-6 large-3 large-offset-9 medium-order-1">
            <a id="doneButton" class="button primary expanded" role="button" href="/reservations/viewres/page">
              <span aria-hidden="true">{{'reaccom.doneButton' | translate}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</main>